export const RC_SUCCESS = 0;

export const RC_ORDER_REFERENCE_BLANK = -100;
export const RC_ORDER_REFERENCE_LENGTH = -101;
export const RC_ORDER_REFERENCE_INVALID = -102;
export const RC_ORDER_REFERENCE_FORMAT = -103;
export const RC_ORDER_REFERENCE_DUP = -104;

export const RC_QUANTITY_INVALID_CHARACTERS = -200;
export const RC_QUANTITY_ZERO = -201;
export const RC_QUANTITY_ADDING_50_PLUS = -202;
export const RC_QUANTITY_MIN_ORDERABLE = -203;
export const RC_QUANTITY_MIN_ORDER_REQUIREMENT = -204;
export const RC_QUANTITY_MAX_ORDER = -205;
export const RC_QUANTITY_MAX_STOCKING_LEVEL = -206;
export const RC_QUANTITY_STOCK_MAX = -207;
export const RC_QUANTITY_PACK = -208;

export const RC_BIN = -300;

export const RC_PART_NUMBER_INVALID = -400;
export const RC_PART_NUMBER_ORDER_TYPE = -401;
export const RC_PART_NUMBER_EXCLUSION = -402;
export const RC_PART_NUMBER_OVERRIDE = -403;
export const RC_PART_NUMBER_NOT_ORDERABLE = -404;
